// extracted by mini-css-extract-plugin
module.exports = {"u-fullWidth":"style_u-fullWidth__2CWHe","u-shrinkAll":"style_u-shrinkAll__2Lgpy","Table-container":"style_Table-container__3TJ6l","Table":"style_Table__2-MRz"};